import { Map, Set } from 'immutable';
import * as actionTypes from '../actions/actionTypes';
import { newTasksBackendClient } from '../../backends/tasks';

export default function () {
    const initialState = Map<string, any>({
        socketUrl: '',
        socketPath: '',
        httpBackendUrl: '',
        tasksBackendClient: undefined,
        userInfoExists: false,
        customerId: undefined,
        userId: undefined,
        browserLocation: undefined,
        authtoken: Map<string, any>(),
        sessionId: undefined,
        analyticsServiceUrl: undefined,
    });

    return function reducer(state = initialState, action: any) {
        switch (action.type) {
            case actionTypes.CONFIGURE_SOCKETURL: {
                return state.set('socketUrl', action.url).set('socketPath', action.path);
            }

            case actionTypes.CONFIGURE_HTTPBACKENDURL: {
                const oldUrl = state.get('httpBackendUrl');

                return oldUrl !== action.url
                    ? state
                          .set('httpBackendUrl', action.url)
                          .set('tasksBackendClient', newTasksBackendClient(action.url))
                    : state;
            }

            case actionTypes.SET_USERINFOEXISTS: {
                return state.set('userInfoExists', action.userInfoExists);
            }

            case actionTypes.SET_CUSTOMERID: {
                return state.set('customerId', action.customerId);
            }

            case actionTypes.SET_USERID: {
                return state.set('userId', action.userId);
            }

            case actionTypes.SET_BROWSERLOCATION: {
                return state.set('browserLocation', {
                    host: window?.location?.host,
                    ...action.location,
                });
            }

            case actionTypes.SET_AUTHTOKEN: {
                return state.setIn(['authtoken', 'current'], action.token);
            }

            case actionTypes.SET_ANALYTICS_SERVICE_URL: {
                return state.set('analyticsServiceUrl', action.url);
            }

            case actionTypes.SET_SESSIONID: {
                return state.set('sessionId', action.sessionId);
            }

            default:
                return state;
        }
    };
}
